(() => {
	const body = document.body;
	const scrollOffset = 1;

	function update() {
		const y = window.scrollY || 0;

		if (y <= scrollOffset) {
			body.classList.remove('scrolled'); // oben → weg
		} else {
			body.classList.add('scrolled'); // gescrollt → da
		}
	}

	update();

	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('load', update);
	window.addEventListener('pageshow', update);
})();
